export const result = {
    "no_results_yet": "Chưa có kết quả nào",
    "see_result": "Xem kết quả",
    "test_result": "Kết quả bài thi",
    "attempt": "Lần",
};
